import { SOIL_TEMPERATURE_PERIOD_FORM_CONFIG } from '..';
import { useModals, createForm, useForm, FormElement } from '@common';
import { useStatisticsWizardStore } from '../stores';

export const useSoilTemperaturePeriod = () => {
  const modals = useModals();

  const statisticsWizardStore = useStatisticsWizardStore();

  const form = createForm(SOIL_TEMPERATURE_PERIOD_FORM_CONFIG);
  const { getChild, valid } = useForm(form.element);

  const fromDateField = getChild('fromDate') as FormElement;
  const toDateField = getChild('toDate') as FormElement;

  const applySoilTemperaturePeriod = async () => {
    const validationResult = await form.validate();

    if (validationResult.valid) {
      modals.openConfirm({
        title: 'statistics.wizard.dialog.applyTemperatures.title',
        text: 'statistics.wizard.dialog.applyTemperatures.text',
        translate: true,
        onConfirm: async () => {
          statisticsWizardStore.applySoilTemperaturePeriod(form.value.value);
          fromDateField.value = null;
          toDateField.value = null;
        }
      });
    }
  };

  return {
    form,
    valid,
    applySoilTemperaturePeriod
  };
};
